import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { call, put, takeEvery, select } from 'redux-saga/effects';
// import * as MypageRequestApi from '../Api/MypageRequestApi';
import * as credit_api from '../Api/credit_api';

export interface CreditState {
    // line_detail: any;
    // credit_comp: boolean;
    // credit_code: any;
    // credit_section_id: any;
    // credit_limit: any;
    credit_detail: any;
    credit_pass: string;
    credit_cd: string;
    // search_rooms_detail:any;
}
const initialState: CreditState = {

    // credit_section_id: 0,
    // credit_comp: false,
    // credit_code: null,
    // credit_limit: null,
    credit_detail: [],
    credit_pass: "",
    credit_cd: ""
    // search_rooms_detail: [],
}



///action 
const actionCreator = actionCreatorFactory();

export const credit_login = actionCreator('CREDIT_LOGIN');
export const change_credit_detail = actionCreator<any>('CHANGE_CREDIT_DETAIL');
export const change_credit_pass = actionCreator<string>('CHANGE_CREDIT_PASS');
export const change_credit_cd = actionCreator<string>('CHANGE_CREDIT_CD');

// export const change_line_detail = actionCreator<any>("CHANGE_LINE_DETAIL");
// export const update_mypage_request = actionCreator<any>('UPDATE_MYPAGE_REQUEST');
// export const change_line_comp = actionCreator<any>("CHANGE_LINE_COMP");

// export const get_line_code = actionCreator<any>("GET_LINE_CODE");
// export const change_line_code = actionCreator<any>("CHANGE_LINE_CODE");
// export const change_line_section_id = actionCreator<any>("CHANGE_LINE_SECTION_ID");

// export const change_line_limit = actionCreator<any>("CHANGE_LINE_LIMIT");
// export const get_search_rooms_detail= actionCreator('GET_SEARCH_ROOMS_DETAIL');
// export const get_search_rooms_detail_success = actionCreator("GET_SEARCH_ROOMS_DETAIL_SUCCESS");


export const creditReducer = reducerWithInitialState(initialState)
    .case(change_credit_detail, (state, payload) => ({ ...state, credit_detail: payload }))
    .case(change_credit_pass, (state, payload) => ({ ...state, credit_pass: payload }))
    .case(change_credit_cd, (state, payload) => ({ ...state, credit_cd: payload }))
// .case(change_line_comp, (state, payload) => ({ ...state, line_comp: payload }))

// .case(change_line_code, (state, payload) => ({ ...state, line_code: payload }))
// .case(change_line_limit, (state, payload) => ({ ...state, line_limit: payload }))
// .case(get_search_rooms_detail_success, (state, payload) => ({ ...state, search_rooms_detal: payload }))
// .case(get_room_details_success, (state, payload) => ({ ...state, room_details: payload }))

// .case(get_response_rooms_success, (state, payload) => ({ ...state, response_rooms: payload }))

// .case(change_showRight, (state, payload) => ({ ...state, showRight: payload }))
// .case(change_showFlag, (state, payload) => ({ ...state, showFlag: payload }))
// .case(change_draggable, (state, payload) => ({ ...state, draggable: payload }))

// .case(get_rooms_success, (state, payload) => ({ ...state, rooms: payload }));








// 「LOGIN_REQUEST」アクションが呼ばれるのを待つ呼ばれたhandleRequestを実行
export const creditSaga = [
    takeEvery('CREDIT_LOGIN', handle_credit_login),
    // takeEvery('UPDATE_MYPAGE_REQUEST', handle_update_mypage_request),
    // takeEvery('GET_LINE_CODE', handle_get_line_code),

    // takeEvery('RENT_AGENTS_REQUEST', handleRentAgentsRequest),
    // takeEvery('RENT_M_REASONS_REQUEST', handleRentMReasonsRequest),
];
// export default masterSaga;



function* handle_credit_login(action: any) {
    const state = yield select();



    const { payload, error } = yield call(credit_api.login, { cd: state.Credit.credit_cd, pass: state.Credit.credit_pass });
    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)

        // const setsubis = payload.map((item:any, i:number) => ({
        //     value: item.setsubiNo,
        //     label: item.setsubiName,
        //   }))

        // 成功時アクション呼び出し


        yield put(change_credit_detail(payload));

        // yield put(get_search_rooms_success(payload));


    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}


// function* handle_update_mypage_request(action: any) {
//     const state = yield select();

//     const { payload, error } = yield call(MypageRequestApi.update, state.Line.mypage_request);

//     // サーバーからのレスポンスデータによる分岐処理
//     if (payload && !error) {
//         console.log(payload)

//         // const setsubis = payload.map((item:any, i:number) => ({
//         //     value: item.setsubiNo,
//         //     label: item.setsubiName,
//         //   }))

//         // 成功時アクション呼び出し


//         yield put(change_line_comp(true));
//         //    yield put(get_search_rooms_detail_success(payload));

//     } else {
//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }
// }


// function* handle_get_line_code(action: any) {
//     const state = yield select();

//     const { payload, error } = yield call(line_auth_api.auth, action.payload);

//     // サーバーからのレスポンスデータによる分岐処理
//     if (payload && !error) {
//         console.log(payload)
//         // const setsubis = payload.map((item:any, i:number) => ({
//         //     value: item.setsubiNo,
//         //     label: item.setsubiName,
//         //   }))

//         // 成功時アクション呼び出し


//         yield put(change_line_code(payload.code));
//         yield put(change_line_section_id(payload.section_id));
//         yield put(change_line_limit(payload.limited_at));
//         //    yield put(get_search_rooms_detail_success(payload));

//     } else {
//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }
// }
